import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({ selector: '[ipmAdVisible]' })
export class AdVisibilityDirective implements OnInit, OnDestroy {
  @Input('ipmAdVisible') enabled: boolean = false;
  @Output() adVisible = new EventEmitter<void>();
  private observer: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (!this.enabled) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.adVisible.emit();
          this.observer.unobserve(this.el.nativeElement);
        }
      },
      { threshold: 0.5 }
    );
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
